"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = void 0;
// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
const react_1 = require("@reduxjs/toolkit/query/react");
const config_1 = require("config");
const utils_1 = require("utils");
const baseQuery = (0, react_1.fetchBaseQuery)({
    baseUrl: config_1.REACT_APP_API_URL,
    prepareHeaders: async (headers) => {
        const hyperDxCookie = (0, utils_1.getCookie)('__rum_sid');
        const testAutomationCookie = (0, utils_1.getCookie)('TestAutomation');
        headers.set('Hyperdx-Session-Info', hyperDxCookie);
        if (testAutomationCookie) {
            headers.set('TestAutomation', testAutomationCookie);
        }
    },
});
const baseQueryWithCamelize = (0, utils_1.camelizeResponse)(baseQuery);
exports.api = (0, react_1.createApi)({
    reducerPath: 'abTestsApi',
    baseQuery: baseQueryWithCamelize,
    endpoints: () => ({}),
    keepUnusedDataFor: 0,
});
